import { FxIdApplicationStoreCreatePaymentHandlerEmbeddingType, FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus, FxIdDomainStoreEnumsSupportedWebPublishingPlatform } from "@fxid/openapi-client";
import OpenApiClient from "@fxid/openapi-client";
import { FxIdSdkAdapterSocialSettingDefault } from "@fxid/sdk-core";
import { getAuthToken } from "@fxid/shared";
import i18next from "i18next";
import { deferred } from "../types/FxIdSdkUtils";
import { VkLoginStatusUserAuthorizedNotRegistered, VkLoginStatusUserNotAuthorized } from "../types/vkplay";
import { FxIdSdkBaseAdapter } from "./FxIdSdkBaseAdapter";
export class FxIdSdkAdapterForVkPlay extends FxIdSdkBaseAdapter {
    constructor(exportedSdk, game, config, dependencies) {
        super(exportedSdk, game, config, dependencies);
        this.exportedSdk = exportedSdk;
        this.game = game;
        this.config = config;
        this.adapter = "vkplay";
        this.defaultSocialSettings = {
            ...FxIdSdkAdapterSocialSettingDefault,
            ui: {
                ...FxIdSdkAdapterSocialSettingDefault.ui,
                disabled: false
            }
        };
        this.paymentReceivedCallback = (data) => {
            log.info("paymentReceivedCallback");
            this.buyProductResolve?.call(this, { transactionId: data.uid });
        };
        this.paymentWindowClosedCallback = () => {
            log.info("paymentWindowClosedCallback");
            this.buyProductReject?.call(this, "User closed payment window");
        };
        this.userInfoCallback = (param) => {
            log.info("userInfoCallback", param);
            if (param.status === "error") {
                this.userInfoCallbackReject?.call(this, param);
            }
            else {
                this.userInfoCallbackResolve?.call(this, param);
            }
        };
        this.getLoginStatusCallback = (param) => {
            log.info("getLoginStatusCallback", param);
            if (param.status === "error") {
                this.getLoginStatusCallbackReject?.call(this, param);
            }
            else {
                this.getLoginStatusCallbackResolve?.call(this, param);
            }
        };
        this.registerUserCallback = (param) => {
            log.info("registerUserCallback", param);
            if (param.status === "error") {
                this.registerUserCallbackReject?.call(this, param);
            }
            else {
                this.registerUserCallbackResolve?.call(this, param);
            }
        };
        this.userProfileCallback = (profile) => {
            log.info("userProfileCallback", profile);
        };
        this.paymentFrameUrlCallback = (url) => {
            log.info("paymentFrameUrlCallback", url);
        };
        this.getAuthTokenCallback = (token) => {
            log.info("getAuthTokenCallback", token);
        };
        this.userConfirmCallback = () => {
            log.info("userConfirmCallback");
        };
        const appId = config.PlatformData.VkontaktePlay?.AppId;
        if (appId == null) {
            throw new Error("No AppId for VkontaktePlay adapter");
        }
        this.appid = appId;
    }
    RegisterShareHandlers() {
        // Это все залипуха. Надо будет менять на нормальные апи
        const sharingHandler = this._dependencies.getSharingHandler();
        if (sharingHandler) {
            sharingHandler.enableShareVk?.(() => {
                const url = `https://vk.com/share.php?url=${window.location}&title=${i18next.t(`seo.${this.game}.title`)}`;
                window.open(url, "__blank");
            });
            sharingHandler.enableShareOk?.(() => {
                const url = `https://connect.ok.ru/offer?url=${window.location}&title=${i18next.t(`seo.${this.game}.title`)}`;
                window.open(url, "__blank");
            });
            sharingHandler.enableShareTelegram?.(() => {
                const url = `https://telegram.me/share/url?url=${window.location}&text=${i18next.t(`seo.${this.game}.title`)}`;
                window.open(url, "__blank");
            });
        }
        return Promise.resolve();
    }
    async BuyProduct(request) {
        const url = new URL(window.location.href);
        const currency = url.searchParams.get("currency") ?? "RUB";
        const paymentRequest = {
            Token: getAuthToken(),
            Game: this.game,
            Sku: request.sku,
            WebPublishingPlatform: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.VkontaktePlay,
            EmbeddingType: FxIdApplicationStoreCreatePaymentHandlerEmbeddingType.Embed,
            Currency: currency,
            VkontaktePlay: {
                IpAddress: "0.0.0.0",
                Uid: this.userInfo?.userId ?? url.searchParams.get("uid") ?? "",
                Currency: currency
            },
            ProductDescriptionHint: request.productDescriptionHint,
            ProductNameHint: request.productNameHint
        };
        if (request.developerPayload != null) {
            paymentRequest.DeveloperPayload = {
                MerchantDeveloperPayload: request.developerPayload
            };
        }
        const createPaymentResult = await OpenApiClient.Store.fxIdWebFeaturesStoreCreatePaymentEndpoint(paymentRequest);
        log.info("Received result from server: %o", createPaymentResult);
        this.currentOrderId = createPaymentResult.TransactionId;
        const { promise, resolve, reject } = deferred();
        this.buyProductResolve = async (data) => {
            log.info("Buy product resolved %o", data);
            await OpenApiClient.Store.fxIdWebFeaturesStoreOrdersSetOptimisticOrderStatusSetOptimisticOrderStatusEndpoint({
                PublicOrderId: createPaymentResult.TransactionId,
                Status: FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus.Completed
            }).catch((e) => log.error("[VKPLAY] Failed to set optimistic status:", e));
            resolve({
                ...data,
                transactionId: createPaymentResult.TransactionId,
                stats: {
                    currency: createPaymentResult.OrderProduct.Currency ?? "",
                    currencyAmount: createPaymentResult.OrderProduct.Price ?? 0,
                    usdAmount: createPaymentResult.OrderProduct.UsdPrice ?? 0
                }
            });
        };
        this.buyProductReject = async (data) => {
            log.info("Buy product rejected %o", data);
            await OpenApiClient.Store.fxIdWebFeaturesStoreOrdersSetOptimisticOrderStatusSetOptimisticOrderStatusEndpoint({
                PublicOrderId: createPaymentResult.TransactionId,
                Status: FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus.Cancelled
            }).catch((e) => log.error("[VKPLAY] Failed to set optimistic status:", e));
            reject(new Error(data));
        };
        const paymentFrameParams = {
            merchant_param: {
                amount: createPaymentResult.OrderPrice,
                description: createPaymentResult.OrderProduct.LocalizedProductDescription,
                // Используем валюту из ответа сервера, а не из URL параметров, чтобы избежать рассогласования
                // между валютой заказа и валютой отправленной в VKPlay
                currency: createPaymentResult.PriceData.Currency,
                public_order_id: createPaymentResult.TransactionId
            }
        };
        log.info("Requesting payment frame with params", paymentFrameParams);
        this.vkExternalApi?.paymentFrame(paymentFrameParams);
        return promise;
    }
    GetSocialInfo() {
        const { promise, resolve, reject } = deferred();
        this.userInfoCallbackResolve = (data) => {
            resolve({
                social: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.VkontaktePlay,
                paymentsAvailable: true,
                userId: data.uid.toString(),
                capabilities: []
            });
        };
        this.userInfoCallbackReject = reject;
        this.vkExternalApi?.userInfo();
        return promise;
    }
    GetLoginStatus() {
        log.info("Requesting login status");
        const { promise, resolve, reject } = deferred();
        this.getLoginStatusCallbackResolve = resolve;
        this.getLoginStatusCallbackReject = reject;
        this.vkExternalApi?.getLoginStatus();
        return promise;
    }
    RegisterUser() {
        log.info("Requesting register user");
        const { promise, resolve, reject } = deferred();
        this.registerUserCallbackResolve = resolve;
        this.registerUserCallbackReject = reject;
        this.vkExternalApi?.registerUser();
        return promise;
    }
    async Initialize() {
        log.info("Initializing VkPlay adapter");
        await new Promise((resolve) => {
            const s = document.createElement("script");
            s.type = "text/javascript";
            s.src = `//vkplay.ru/app/${this.appid}/static/mailru.core.js`;
            s.addEventListener("load", function (e) {
                log.info("Script loaded");
                resolve();
            }, false);
            const head = document.getElementsByTagName("head")[0];
            head.appendChild(s);
            log.info("Script added");
        });
        log.info("Initializing api");
        this.vkExternalApi = await window.iframeApi({
            appid: this.appid,
            getLoginStatusCallback: this.getLoginStatusCallback.bind(this),
            userInfoCallback: this.userInfoCallback.bind(this),
            userProfileCallback: this.userProfileCallback.bind(this),
            registerUserCallback: this.registerUserCallback.bind(this),
            paymentFrameUrlCallback: this.paymentFrameUrlCallback.bind(this),
            getAuthTokenCallback: this.getAuthTokenCallback.bind(this),
            paymentReceivedCallback: this.paymentReceivedCallback.bind(this),
            paymentWindowClosedCallback: this.paymentWindowClosedCallback.bind(this),
            userConfirmCallback: this.userConfirmCallback.bind(this)
        });
        log.info("Api initialized");
        const loginStatus = await this.GetLoginStatus();
        log.info("Received login status: " + loginStatus);
        if (loginStatus.loginStatus === VkLoginStatusUserNotAuthorized) {
            this.vkExternalApi.authUser();
            // https://documentation.vkplay.ru/f2p_vkp/f2pb_js_vkp#authUser
            // Авторизация пользователя. При вызове метода появляется окно авторизации.
            // После авторизации страница будет перезагружена, далее можно запросить статус и информацию о пользователе.
            await new Promise((resolve) => {
                log.info("Eternal promise. VkPlay MUST reload page");
            });
            document.location.reload();
        }
        else if (loginStatus.loginStatus === VkLoginStatusUserAuthorizedNotRegistered) {
            await this.RegisterUser();
            this.vkExternalApi?.reloadWindow();
            document.location.reload();
        }
        this.userInfo = await this.GetSocialInfo();
        this._dependencies.setUserId(this.userInfo.userId);
        this._dependencies.setUserDisplayName(`#${this.userInfo.userId}`);
    }
    StoreCurrency() {
        const url = new URL(window.location.href);
        const currency = url.searchParams.get("currency") ?? "RUB";
        return Promise.resolve(currency);
    }
    StatInitialize(request) {
        return Promise.resolve(undefined);
    }
    StatEvent(request) {
        return Promise.resolve(undefined);
    }
}
FxIdSdkAdapterForVkPlay.VkPlayHost = "vkplay.ru";
